import { Component, OnInit, Input, Renderer2, ElementRef } from "@angular/core";
import { CandidateService } from "src/app/services/candidate.service";
import { AuthService } from "src/app/services/auth.service";
import { MatDialog } from "@angular/material/dialog";

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { TermsAndConditionsComponent } from "../../terms-and-conditions/terms-and-conditions.component";
import { PrivacyPolicyComponent } from "../../privacy-policy/privacy-policy.component";
import { SnackBarService } from "../../services/snack-bar.service";

@Component({
  selector: "app-footer-one",
  templateUrl: "./footer-one.component.html",
  styleUrls: ["./footer-one.component.scss"],
})
export class FooterOneComponent implements OnInit {
  @Input() class: string = "footer-light"; // Default class
  @Input() themeLogo: string = "assets/images/logos/final-logo.png"; // Default Logo
  // @Input() themeLogo: string = 'assets/images/icon/logo.png'
  @Input() newsletter: boolean = true; // Default True
  form: FormGroup;
  currentYear: number;
  isLoggedIn: boolean = false;
  constructor(
    private candidateService: CandidateService,
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private el: ElementRef,
    private snackbarService:SnackBarService
   

  ) {
    this.authService.getLoginStatus().subscribe((status) => {
      this.isLoggedIn = status;
    });
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.scrollToTop();
  }
  createSubscription() {
    // console.log("selectedItem", this.selectedItem)

    let reqObj = {
      email: this.form.value["email"],
    };
    console.log("Form", this.form.value);
    console.log("reqObj", reqObj);
    // return;
    this.candidateService.createSubscription(reqObj).subscribe((resp: any) => {
      console.log("Rec profile update success", resp);

      if (resp.statusCode == 200) {
        // this.form.value['email']="";
        this.snackbarService.open(resp.supportMessage, 'close', 3000, "center", "top")

        this.form.reset();
        // this.errorStatus =true;
        // this.errorMsg = resp.supportMessage;
        // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"","center","top",3);
      }
    });
  }

  goTo(): void {
    // this.dialog.open(TermsAndConditionsComponent);
    this.router.navigate(['terms-and-conditions'])
  }

  goToPrivacy(): void {
    this.router.navigate(['privacy'])
  }

  scrollToTop() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  openPlayStore(){
    window.open('https://play.google.com/store/apps/details?id=com.app.whiterobe', '_blank');
  
  }

  openEmployement(){
    this.router.navigate(['available-jobs'])
  }
  openHiring(){
    this.router.navigate(['immediate-hirings'])
  }
  openProduct(){
    this.router.navigate(['products'])
  }
  openContact(){
    this.router.navigate(['contact-us'])
  }
  openPricing(){
    this.router.navigate(['pricing-policy'])
  }
  openRefund(){
    this.router.navigate(['refund-policy'])
  }
  openCancellation(){
    this.router.navigate(['cancellation-policy'])
  }
  openShipping(){
    this.router.navigate(['shipping-policy'])
  }

  
}
